var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content s-scheme"},[_c('h3',{staticClass:"title-p"},[_vm._v(_vm._s(_vm.leftTitle))]),_vm._l((_vm.items),function(item1){return _c('div',{key:item1.index},[_c('h4',[_vm._v(_vm._s(item1.title))]),_c('el-divider'),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(item1.content)}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }